import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu", "openMenuIcon", "closeMenuIcon"];

  toggle() {
    if (this.menuTarget.classList.contains("hidden")) {
      this.open();
    } else {
      this.close();
    }
  }

  open() {
    this.menuTarget.classList.replace("hidden", "flex");
    this.openMenuIconTarget.classList.toggle("hidden");
    this.closeMenuIconTarget.classList.toggle("hidden");
  }

  close() {
    this.menuTarget.classList.replace("flex", "hidden");
    this.openMenuIconTarget.classList.toggle("hidden");
    this.closeMenuIconTarget.classList.toggle("hidden");
  }
}
